module.exports = __webpack_public_path__ + "static/media/libro10.94e7a44b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro10.png
// module id = 358
// module chunks = 0